import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { EnvironmentService } from '../../services/environment.service';

@Injectable({ providedIn: 'root' })
export class IsElectronAppGuard implements CanActivate {
    readonly _electronService = inject(EnvironmentService);
    readonly _router = inject(Router);

    canActivate(): boolean {
        return this._electronService.isElectron();
    }
}